import { useState } from 'react';
import DialogHeader from 'src/components/Dialog/DialogHeader';
import {
    Button,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    Grid
} from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import { EEPLanguageModel } from 'src/models/businessManager/businessManager.model';
import ASMSelectV2 from 'src/components/Select/ASMSelectV2';
const requireStyle = {
    '& .MuiOutlinedInput-notchedOutline': {
        borderColor: 'red !important',
    },
    '& .MuiInputLabel-root': {
        color: 'red !important',
    }
};
export default function DialogLinguisticSkill(props) {
    const { t } = useTranslation();

    const data: EEPLanguageModel = props.data;
    const handleChange = props.handleChange;
    const openDialogSave = props.openDialogSave;
    const title = props.title;
    const levels = props.levels;
    const handleChangeLevel = props.handleChangeLevel;

    const handleCloseDialogSave = () => {
        props.handleCloseDialogSave()
    }

    const handleClickSave = (e) => {
        e.preventDefault();
        props.handleClickSave()
    }
    return (
        <>
            <Dialog open={openDialogSave} maxWidth={'md'} fullWidth>
                <DialogHeader title={title} />
                <DialogContent style={{ overflowY: "hidden", paddingBottom: 0, paddingTop: 10 }}>
                    <Grid container direction="row" alignItems="stretch" sx={{ padding: 1 }} spacing={1}>
                        <Grid item xs={6} style={{ paddingLeft: 0 }}>
                            <TextField
                                label={t('language.lang')}
                                variant="outlined"
                                required
                                name="name"
                                value={data.name}
                                fullWidth
                                inputProps={{
                                    maxLength: 126
                                }}
                                sx={(data.name == null || data.name == "") ? requireStyle : {}}
                                onChange={handleChange}
                            />
                        </Grid>
                        <Grid item xs={6} >
                            <ASMSelectV2
                                labelId="level-label"
                                label={t('level.label')}
                                items={levels}
                                required
                                withRating={false}
                                withMultiSelect={false}
                                onChange={handleChangeLevel}
                                // placeholder={t('level.select')}
                                name="idLanguageLevel"
                                defaultValue={data.idLanguageLevel >= 0 ? [data.idLanguageLevel] : []}
                                emptyField={(data.idLanguageLevel == 0 || data.idLanguageLevel == null)}
                                fromLanguage={true}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ justifyContent: "flex-start", paddingLeft: 24, paddingTop: 14, paddingBottom: 16 }}>
                    <Button
                        variant="contained"
                        style={{ marginRight: 5 }}
                        onClick={handleClickSave}
                    >
                        <Trans>button.save</Trans>
                    </Button>
                    <Button
                        variant="contained"
                        style={{ marginRight: 10 }}
                        color="error"
                        onClick={handleCloseDialogSave}
                    >
                        <Trans>button.cancel</Trans>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
}
